import { useEffect } from 'react';
import { useTheme } from '../hooks/useTheme';

const ThemeInitializer: React.FC = () => {
  const { isDark } = useTheme();

  useEffect(() => {
    // Este componente simplemente ejecuta el hook useTheme
    // para asegurar que el tema se inicialice correctamente
  }, [isDark]);

  return null;
};

export default ThemeInitializer;
